import { CART_ACTION_TYPES } from "./cart-action-types";

const INITIAL_STATE = {
  cartItems: [],
  showCart: false,
};

export const cartReducer = (state = INITIAL_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case CART_ACTION_TYPES.SET_CART_ITEMS:
      return {
        ...state,
        cartItems: payload,
      };
    case CART_ACTION_TYPES.TOGGLE_SHOW_CART:
      return {
        ...state,
        showCart: payload,
      };
    default:
      return state;
  }
};
